import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import StatisticsCards from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'
import type { StatisticsCardItem } from '@/views/dashboard/_components/statistics-cards/types'
import type { RansomwareIncidentStatCardKey } from './ransomware-incident-statistics-cards.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'statistics-cards',
  props: {
    ransomwareEventCount: { default: 0 },
    blockedEventCount: { default: 0 }
  },
  emits: ["statClick"],
  setup(__props: any, { emit: __emit }) {

const { t, locale } = useI18n()
const props = __props

const emit = __emit

const statisticsItems = computed((): StatisticsCardItem[] => {
  void locale.value
  const all = props.ransomwareEventCount ?? 0
  const blocked = props.blockedEventCount ?? 0
  return [
    {
      label: t('ransomwareIncident.ransomwareEventCount'),
      value: all,
      span: 12,
      clickable: all > 0,
      events: {
        click: () => {
          if (all <= 0) return
          emit('statClick', 'allIncidents')
        }
      }
    },
    {
      label: t('ransomwareIncident.blockedEventCount'),
      value: blocked,
      span: 12,
      clickable: blocked > 0,
      events: {
        click: () => {
          if (blocked <= 0) return
          emit('statClick', 'blockedOutcomes')
        }
      }
    }
  ]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StatisticsCards, { items: statisticsItems.value }, null, 8, ["items"]))
}
}

})